var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SfSection',{staticClass:"section",attrs:{"title-heading":_vm.title}},[_c('Carousel',{directives:[{name:"show",rawName:"v-show",value:(_vm.mappedProducts.length > 0),expression:"mappedProducts.length > 0"}],staticClass:"product-carousel",attrs:{"data-cy":"category-products-carousel","settings":{
      type: 'carousel',
      perView: 6,
      perTouch: 2,
      gap: 7,
      breakpoints: {
        1680: {
          perView: 6,
          perTouch: 2,
        },
        1480: {
          perView: 5,
        },
        1280: {
          perView: 4,
        },
        991: {
          perView: 3,
        },
        580: {
          rewind: false,
          perView: 2.4,
          peek: {
            before: 0,
            after: 0,
          },
        },
      },
    }}},_vm._l((_vm.mappedProducts),function(product,i){return _c('CarouselItem',{key:i,staticClass:"carousel__item"},[_c('ProductContainer',{attrs:{"product":product}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }